import AOS from 'aos';

/**
 * Animate on Scroll
 */
export function animateOnScroll() {
	AOS.init(
		{
			disable: 'mobile'
		}
	);
}
